export default __webpack_public_path__ + "static/media/Captain's Chestplate of the Ascending Kingdom.46ed8078.jpg";